import { Announcement } from "@/src/types/types";

import wretch from "wretch";

const ANNOUNCEMENTS_URL = import.meta.env.VITE_BAANA_ANNOUNCEMENTS_URL;

const validateAnnouncementsUrl = (url: string | undefined): string => {
  if (!url) {
    throw new Error(
      "VITE_BAANA_ANNOUNCEMENTS_URL environment variable is not defined"
    );
  }

  try {
    new URL(url);
    return url;
  } catch {
    throw new Error(
      `VITE_BAANA_ANNOUNCEMENTS_URL environment variable contains an invalid URL: ${url}`
    );
  }
};

export const getAnnouncements = async () => {
  try {
    const validatedUrl = validateAnnouncementsUrl(ANNOUNCEMENTS_URL);
    const res: Announcement[] = await wretch(validatedUrl)
      .headers({
        "cache-control": "no-cache"
      })
      .get()
      .json();

    return res;
  } catch (error) {
    console.error("Failed to fetch announcements:", error);
    return [];
  }
};
